<template>
  <div class="clip-item" :class="{ disabled: disabled }">
    <span class="text-left">{{ clip.start_time }}</span>
    <span class="title" :title="clip.name">{{ clip.name }}</span>
    <span>{{ duration }}</span>
    <div class="clip-buttons">
      <button-component
        variant="icon"
        v-if="processing"
        class="rotate"
        title="CLIP.processed"
      >
        <hourglass-icon />
      </button-component>
      <download-button
        btnVariant="icon"
        v-else-if="success"
        :url="clip.out_url"
        title="CLIP.download"
      >
        <download-icon />
      </download-button>
      <button-component
        variant="icon"
        v-else
        disabled
        title="CLIP.failed"
      >
        <x-mark-icon />
      </button-component>
      <button-component
        variant="icon"
        @btn-click="playClip"
        title="VIDEO.play"
      >
        <play-icon />
      </button-component>
      <button-component
        v-if="clip.is_owner"
        variant="icon"
        @btn-click="deleteClip"
        title="CLIP.delete"
      >
        <trash-icon />
      </button-component>
      <button-component
        v-if="clip.is_owner && success"
        variant="icon"
        @btn-click="showPopup($route.params.id)"
        title="CLIP.share"
      >
      <share-icon />
    </button-component>
    </div>
  </div>
</template>

<script>
import ClipItem from './clipItem.js';
import {secondsFromString} from '@/utils/helpers';

export default {
  name: 'CreatedClipItem',
  extends: ClipItem,
  methods: {
    playClip() {
      const start = secondsFromString(this.clip.start_time);
      const duration = secondsFromString(this.clip.duration);

      this.$emit('playClip', {
        start: start,
        end: start + duration,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.clip-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  flex-wrap: wrap;
  button {
    svg {
      height: 1.25rem;
      width: 1.25rem;
    }
  }
}

.clip-item {
  display: contents;
  text-transform: none;
}

.title {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.rotate {
  animation: flip 1s linear infinite;
}
.disabled * {
  pointer-events: none;
  filter: var(--disable-filter);
}
</style>
